import gql from "graphql-tag";

export const GET_INITIATED_PAGINATED_DATA = gql`
  query getPaginatedData($UISorting: UISortingCases!, $UISearch: UISearch!) {
    getPaginatedData(UISorting: $UISorting, UISearch: $UISearch) {
      InitiatedCases {
        created
        application_id
        employer
        soc_title
        jobTitle
        foreign_worker_name
        external_status
        form_id
        formVersionId
      }
      total_count
    }
  }
`;

export const GET_PRESUBMITTED_PAGINATED_DATA = gql`
  query getPaginatedData($UISorting: UISortingCases!, $UISearch: UISearch!) {
    getPaginatedData(UISorting: $UISorting, UISearch: $UISearch) {
      PresubmittedCases {
        submitted
        application_id
        case_number
        employer
        soc_title
        jobTitle
        foreign_worker_name
        external_status
        form_id
      }
      total_count
    }
  }
`;

export const GET_SUBMITTED_PAGINATED_DATA = gql`
  query getPaginatedData($UISorting: UISortingCases!, $UISearch: UISearch!) {
    getPaginatedData(UISorting: $UISorting, UISearch: $UISearch) {
      SubmittedCases {
        hasActiveNotification
        applicationId
        caseNumber
        caseStatus
        externalStatus
        empBusinessName
        jobTitle
        dateSubmitted
        visaType
        foreign_worker_name
        caseMetadata {
          randomizationInfo
        }
      }
      total_count
    }
  }
`;

export const GET_LINKING_PAGINATED_DATA = gql`
  query getPaginatedData(
    $UISorting: UISortingCases!
    $UISearch: UISearch!
    $getCasesInput: getCasesInput!
  ) {
    getPaginatedData(
      getCasesInput: $getCasesInput
      UISearch: $UISearch
      UISorting: $UISorting
    ) {
      LinkableCases {
        dateSubmitted
        caseMetadata {
          determinationDate
        }
        caseNumber
        externalStatus
        applicationId
        empBusinessName
        jobTitle
        empFein
        suggestedSocCode
        pwdLinkingSocCode
      }
      total_count
    }
  }
`;

export const GET_LINKING_790A_PAGINATED_DATA = gql`
  query getPaginatedData(
    $UISorting: UISortingCases!
    $UISearch: UISearch!
    $getCasesInput: getCasesInput!
  ) {
    getPaginatedData(
      getCasesInput: $getCasesInput
      UISearch: $UISearch
      UISorting: $UISorting
    ) {
      LinkableCases {
        caseNumber
        caseStatus
        dateSubmitted
        empBusinessName
        jobTitle
        jobBeginDate #start_date_need
        jobEndDate #end_date_need
        userId
      }
      total_count
    }
  }
`;

export const GET_LINKABLE_REGISTRATION_NUMBER_PAGINATED_DATA = gql`
  query getPaginatedData(
    $UISorting: UISortingCases!
    $UISearch: UISearch!
    $getCasesInput: getCasesInput!
  ) {
    getPaginatedData(
      getCasesInput: $getCasesInput
      UISearch: $UISearch
      UISorting: $UISorting
    ) {
      RegistrationNumberCases {
        registrationNumber
        empBusinessName
        empFein
        jobMsa
        tempneedNature
        tempneedStartDayOfYear
        tempneedEndDayOfYear
        jobTitle
        numberOfWorkers
        validityStartDate
        validityEndDate
      }
      total_count
    }
  }
`;

export const GET_HISTORICAL_PAGINATED_DATA = gql`
  query getPaginatedData($UISorting: UISortingCases!, $UISearch: UISearch!) {
    getPaginatedData(UISorting: $UISorting, UISearch: $UISearch) {
      HistoricalCases {
        hasActiveNotification
        applicationId
        caseNumber
        caseStatus
        externalStatus
        empBusinessName
        jobTitle
        dateSubmitted
        foreign_worker_name
        visaType
        caseMetadata {
          randomizationInfo
          determinationDate
        }
      }
      total_count
    }
  }
`;

export const GET_APPEAL_PAGINATED_DATA = gql`
  query getPaginatedData($UISorting: UISortingCases!, $UISearch: UISearch!) {
    getPaginatedData(UISorting: $UISorting, UISearch: $UISearch) {
      AppealCases {
        hasActiveNotification
        applicationId
        caseNumber
        caseStatus
        externalStatus
        empBusinessName
        jobTitle
        dateSubmitted
        foreign_worker_name
        appealsReceiptDate
        visaType
        caseMetadata {
          randomizationInfo
          determinationDate
        }
      }
      total_count
    }
  }
`;
export const GET_REGISTRATION_NUMBER_PAGINATED_DATA = gql`
  query getPaginatedData($UISorting: UISortingCases!, $UISearch: UISearch!) {
    getPaginatedData(UISorting: $UISorting, UISearch: $UISearch) {
      RegistrationNumberCases {
        registrationNumber
        empBusinessName
        jobTitle
        jobMsa
        numberOfWorkers
        validityStartDate
        validityEndDate
        status
      }
      total_count
    }
  }
`;

export const GET_PAGINATED_COUNT = gql`
  query getPaginatedCount {
    getPaginatedCount {
      Form9141 {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form9141C {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form9142B {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        RegistrationNumber {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form9142C {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form790A {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form9142A {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form9035 {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
      Form9089 {
        Initiated {
          Total
        }
        Presubmitted {
          Total
        }
        Submitted {
          Total
          hasActiveNotification
        }
        Historical {
          Total
          hasActiveNotification
        }
        Appeal {
          Total
          hasActiveNotification
        }
        Total
        hasActiveNotification
      }
    }
  }
`;
